import React, { useEffect, useState } from "react";
import {
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardSubtitle,
	IonCardTitle,
	IonCol
} from "@ionic/react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Utils from "../utils/utils";
import useStore from "../store/store";

const DashboardCards = ({ from, to }: any) => {
	let [rentTotal, setRentTotal] = useState(0);
	let [expanseTotal, setExpanseTotal] = useState(0);
	let [overdue, setOverdue] = useState(0);
	const { t } = useTranslation();
	const { token } = useStore(state => state);

	useEffect(() => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/transactions/get-total`,
				{
					from,
					to
				},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => {
				setRentTotal(res.data.incomeTotal);
				setExpanseTotal(res.data.expanseTotal);
			})
			.catch(err => console.log(err));
	}, [from, to]);

	useEffect(() => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/transactions/get-overdue`,
				{},
				{
					headers: { rentapp_auth: token }
				}
			)
			.then(res => setOverdue(res.data.overdue))
			.catch(err => console.log(err));
	}, []);

	return (
		<>
			<IonCol size-xs="12" size-sm="12" size-md="4" size-lg="4">
				<IonCard>
					<IonCardHeader>
						<IonCardTitle>{t("expanses")}</IonCardTitle>
						<IonCardSubtitle>
							{t("totalDueExpanses")}
						</IonCardSubtitle>
					</IonCardHeader>

					<IonCardContent>
						<h1>
							{t("currencySymbol")}
							{Utils.formatToCurrency(expanseTotal)}
						</h1>
					</IonCardContent>
				</IonCard>
			</IonCol>
			<IonCol size-xs="12" size-sm="12" size-md="4" size-lg="4">
				<IonCard>
					<IonCardHeader>
						<IonCardTitle>{t("rent")}</IonCardTitle>
						<IonCardSubtitle>{t("rentCollected")}</IonCardSubtitle>
					</IonCardHeader>

					<IonCardContent>
						<h1>
							{t("currencySymbol")}
							{Utils.formatToCurrency(rentTotal)}
						</h1>
					</IonCardContent>
				</IonCard>
			</IonCol>
			<IonCol size-xs="12" size-sm="12" size-md="4" size-lg="4">
				<IonCard>
					<IonCardHeader>
						<IonCardTitle>{t("overdueRent")}</IonCardTitle>
						<IonCardSubtitle>
							{t("overdueRentCurrentMonth")}
						</IonCardSubtitle>
					</IonCardHeader>

					<IonCardContent>
						<h1>
							{t("currencySymbol")}
							{Utils.formatToCurrency(overdue)}
						</h1>
					</IonCardContent>
				</IonCard>
			</IonCol>
		</>
	);
};

export default DashboardCards;
